import store from "@/store/index";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Vue from "vue";
import VueRouter from "vue-router";
import tokenFunc from '@/config/static/token'
NProgress.configure({ showSpinner: false });
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    meta: {
      name: "home",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/HomeView.vue"),
  },
  {
    path: "/landing",
    name: "Landing",
    meta: {
      header: true,
      footer: true,
      projectPage: 29,
    },
    component: () => import("../views/Landing/index.vue"),
  },
  {
    path: "/vip_open_success/:discount",
    name: "PaySuccess",
    meta: {
      header: true,
      footer: true,
    },
    component: () => import("../views/Paysuccess/index.vue"),
  },
  {
    path: "/user",
    name: "User",
    meta: {
      header: true,
      footer: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "User" */
        "../../index/views/userConfig/index.vue"
      ),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "Login" */ "../views/Login/index.vue"),
  },
  {
    path: "/toggle-team",
    name: "Team",
    component: () => import(/* webpackChunkName: "Team" */ "../views/Team/index.vue"),
  },
  {
    path: "/article",
    name: "Article",
    component: () => import(/* webpackChunkName: "Team" */ "../views/Article/index.vue"),
  },

  {
    path: "/contech",
    name: "contech",
    meta: {
      name: "contech",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/ContechView.vue"),
  },
  {
    path: "/about",
    name: "about",
    meta: {
      name: "about",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/platform",
    name: "platform",
    meta: {
      name: "platform",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/PlatformView.vue"),
  },
  {
    path: "/report",
    name: "report",
    meta: {
      name: "report",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "report" */ "../views/Report/index.vue"),
  },
  {
    path: "/report-image",
    name: "reportImage",
    meta: {
      name: "reportImage",
      header: true,
      footer: false,
    },
    component: () => import(/* webpackChunkName: "report" */ "../views/Report/image.vue"),
  },
  {
    path: "/report/:id",
    name: 'reportDetail',
    meta: {
      name: "reportDetail",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "reportDetail" */ "../views/Report/detail.vue"),
  },
  {
    path: "/lab",
    name: "lab",
    meta: {
      name: "lab",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/LabView.vue"),
  },
  {
    path: "/case",
    name: "case",
    meta: {
      name: "case",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/CaseView.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    meta: {
      name: "case",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "DetailView" */ "../views/DetailView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    meta: {
      name: "contact",
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/ContactView.vue"),
  },
  {
    path: "/supply",
    name: "supply",
    meta: {
      name: "product",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/product/supply.vue"),
  },
  {
    path: "/output",
    name: "output",
    meta: {
      name: "product",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/product/output.vue"),
  },
  {
    path: "/manage",
    name: "manage",
    meta: {
      name: "product",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/product/manage.vue"),
  },
  {
    path: "/fission",
    name: "fission",
    meta: {
      name: "product",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/product/fission.vue"),
  },
  {
    path: "/data",
    name: "data",
    meta: {
      name: "product",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/product/data.vue"),
  },
  {
    path: "/private",
    name: "private",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/private.vue"),
  },
  {
    path: "/purchase",
    name: "purchase",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/purchase.vue"),
  },
  {
    path: "/brand",
    name: "brand",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/brand.vue"),
  },
  {
    path: "/marketing",
    name: "marketing",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/marketing.vue"),
  },
  {
    path: "/finance",
    name: "finance",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/finance.vue"),
  },
  {
    path: "/education",
    name: "education",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/education.vue"),
  },
  {
    path: "/car",
    name: "car",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/car.vue"),
  },
  {
    path: "/chain",
    name: "chain",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/chain.vue"),
  },
  {
    path: "/retail",
    name: "retail",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/retail.vue"),
  },
  {
    path: "/network",
    name: "network",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/network.vue"),
  },
  {
    path: "/house",
    name: "house",
    meta: {
      name: "solution",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/solution/house.vue"),
  },
  {
    path: "/qylogin",
    name: "Qylogin",
    component: () => import(/* webpackChunkName: "Login" */ "../views/Login/qylogin.vue"),
  },
  {
    path: "/maintain",
    name: "Maintain",
    component: () => import(/* webpackChunkName: "Login" */ "../views/maintain.vue"),
  },
  {
    path: "/aigc",
    name: "AIGC",
    meta: {
      name: "aigc",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "AIGC" */ "../views/AIGC/Aigc.vue"),
  },
  {
    path: "/planDetail",
    name: "PlanDetail",
    meta: {
      name: "PlanDetail",
    },
    component: () => import(/* webpackChunkName: "PlanDetail" */ "../views/AIGC/detail/detail.vue"),
  },
  {
    path: "/aippt",
    name: "AIPPT",
    meta: {
      name: "aippt",
      header: true,
      footer: true,
    },
    component: () => import(/* webpackChunkName: "AIPPT" */ "../views/AIPPT/AIPPT.vue"),
  },
  {
    path: "*",
    redirect: "/",
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})
/**
 * 加载逻辑： 首先加载用户中心文件， 前提保证加载完毕， 再去进行请求是否存在用户中心，
 */
router.beforeEach ((to, from, next) => {
  tokenFunc.proxyInfo(callback)
  function callback () {
    NProgress.start()
    const data = tokenFunc.getToken();
    if (data) {
      store.dispatch('loginInfo').then(() => {
        next()
      })
    } else {

      next()
    }
    if (to.path === '/login.html') {
      if (to.query.path) {
        next(to.query.path)
      } else {
        next('/')
      }
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
export default router;
